import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import Buttons from 'components/molecules/buttons';
import { Form } from 'components/organisms';
import { channelInitialValues } from 'components/organisms/forms/channel/ChannelForm';
import { useClientMode } from 'hooks/useClientMode';
import { useParamId } from 'hooks/useParamId';
import { PiNavigationArrow } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useDeleteChannel, useGetChannel, useGetChannelVideosInfinite } from 'services/channel';
import { useSyncChannel } from 'services/channel/sync';
import { IChannelSyncAll } from 'services/channel/types/query';
import { onErrorShowToast } from 'utils/service/errorHandler';

export enum ChannelTabs {
  contract,
  video,
}

const Channel = () => {
  const channelId = useParamId('channel');
  const navigate = useNavigate();

  const getChannel = useGetChannel(channelId);
  const deleteChannel = useDeleteChannel(channelId);
  const syncChannel = useSyncChannel();

  const getVideos = useGetChannelVideosInfinite(channelId, undefined, false);

  const onSyncChannel = async (method: keyof IChannelSyncAll, startCounter?: () => void) => {
    await syncChannel.mutateAsync(
      {
        channelId,
        updateChannel: method === 'updateChannel',
        updateVideos: method === 'updateVideos',
        addNewVideos: method === 'addNewVideos',
      },
      {
        onSuccess: async () => {
          await getChannel.refetch();
          await getVideos.refetch();
          startCounter && startCounter();
        },
      },
    );
  };

  const onRemoveChannel = async () => {
    await deleteChannel.mutateAsync(undefined, {
      onError: (error) => onErrorShowToast(error),
      onSuccess: () => navigate('/channel'),
    });
  };

  const navigateToYtChannel = (channelId: string) => {
    const targetPath = `https://www.youtube.com/channel/${channelId}`;
    window.open(targetPath, '_blank');
  };

  const clientMode = useClientMode();

  return (
    <Form.Channel
      status={{ isLoading: getChannel.isLoading, displayMode: true }}
      i18nextPrefix="channel"
      initialValues={
        getChannel.data
          ? {
              ...channelInitialValues,
              ...getChannel.data,
              settlementInfo: getChannel.data.settlementInfo ?? channelInitialValues.settlementInfo,
            }
          : channelInitialValues
      }
      onSubmit={() => {}}
      tittle={getChannel.data?.name ?? '-'}
      topbarContent={
        <div className="flex items-center gap-2">
          {' '}
          <div className="flex">
            {getChannel.data ? (
              <Button
                type="button"
                isClear
                className="flip-icon-x"
                onlyIcon
                onClick={() => navigateToYtChannel(getChannel.data.externalChannelId)}
              >
                <Button.Icon icon={<PiNavigationArrow />} />
              </Button>
            ) : null}

            {clientMode.isActive && (
              <>
                <Buttons.ChannelSync
                  lastSyncDate={getChannel.data?.lastSyncDate}
                  onSync={onSyncChannel}
                  isPending={syncChannel.isPending}
                />{' '}
                <MagellanPopups.DeleteWarning
                  name={getChannel.data?.name}
                  onRemove={onRemoveChannel}
                />
              </>
            )}
          </div>
        </div>
      }
    />
  );
};

export default Channel;
